import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
  Box,
  Stack,
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import { v4 } from "uuid";

const getDefaultState = () => ({
  todo: {
    title: "To-Do",
    items: [
      { id: v4(), name: "Cook dinner" },
      {
        id: v4(),
        name: "Sign up for training",
      },
    ],
  },
  inprogress: {
    title: "In-Progress",
    items: [
      {
        id: v4(),
        name: "Submit Maths Assignment",
      },
    ],
  },
  done: {
    title: "Done",
    items: [{ id: v4(), name: "Call the vet" }],
  },
  delete: {
    title: "Delete",
    items: [],
  },
});

const App = () => {
  const [text, setText] = useState("");
  const [state, setState] = useState(() => {
    const savedState = localStorage.getItem("todoState");
    return savedState ? JSON.parse(savedState) : getDefaultState();
  });

  useEffect(() => {
    localStorage.setItem("todoState", JSON.stringify(state));
  }, [state]);

  const handleDragEnd = ({ destination, source }) => {
    if (!destination) return;

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    )
      return;

    const itemcopy = { ...state[source.droppableId].items[source.index] };

    if (
      destination.droppableId === "delete" &&
      source.droppableId !== "delete"
    ) {
      setState((prev) => {
        prev = { ...prev };
        prev[source.droppableId].items.splice(source.index, 1);
        return prev;
      });
    } else {
      setState((prev) => {
        prev = { ...prev };
        prev[source.droppableId].items.splice(source.index, 1);
        prev[destination.droppableId].items.splice(
          destination.index,
          0,
          itemcopy
        );
        return prev;
      });
    }
  };

  const addItem = () => {
    if (!text) return;

    setState((prev) => {
      return {
        ...prev,
        todo: {
          title: "To-Do",
          items: [{ id: v4(), name: text }, ...prev.todo.items],
        },
      };
    });

    setText("");
  };

  return (
    <Box>
      <Stack margin={4} direction="row" style={{ justifyContent: "center" }}>
        <TextField
          size="small"
          type="text"
          placeholder="Add your new todo"
          value={text}
          onChange={(e) => setText(e.target.value)}
          className="custom-textfield"
        />
        <Button
          variant="contained"
          onClick={addItem}
          sx={{
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          }}
        >
          Add
        </Button>
      </Stack>
      <Box style={{ display: "flex" }}>
        <DragDropContext onDragEnd={handleDragEnd}>
          {Object.entries(state).map(([key, data], index, array) => (
            <Box
              key={key}
              style={{
                width: "100%",
                justifyContent: "space-around",
                marginRight: index === array.length - 1 ? "0" : "10px",
              }}
            >
              <Box
                padding={1}
                sx={{
                  bgcolor:
                    data.title === "In-Progress"
                      ? "#feedb9"
                      : data.title === "Done"
                      ? "#c1f0d0"
                      : data.title === "Delete"
                      ? "#dddff8"
                      : "#b7f4f7",
                }}
              >
                <Typography
                  align="center"
                  sx={{
                    color:
                      data.title === "In-Progress"
                        ? "#e7a70c"
                        : data.title === "Done"
                        ? "#2db373"
                        : data.title === "Delete"
                        ? "#8464d6"
                        : "#1ab9bd",
                  }}
                >
                  {data.title}
                </Typography>
              </Box>
              <Droppable droppableId={key}>
                {(provided) => (
                  <Box
                    padding={1}
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                  >
                    {data.items.map((element, index) => (
                      <Draggable
                        key={element.id}
                        index={index}
                        draggableId={element.id.toString()}
                      >
                        {(provided) => (
                          <Card
                            variant="outlined"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            sx={{
                              marginBottom: "4px",
                            }}
                          >
                            <CardContent>
                              <Typography>{element.name}</Typography>
                            </CardContent>
                          </Card>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </Box>
                )}
              </Droppable>
            </Box>
          ))}
        </DragDropContext>
      </Box>
    </Box>
  );
};

export default App;
